/* eslint-disable */
import { api } from './../../api.js';

const state = {
    snackBar : false,
    text: '',
};

const getters = {
    getSnackBarActive : (state) => {
        return state.snackBar;
    },
    getSnackBarText : (state) => {
        return state.text;
    },
}

const mutations = {
    setSnackBar : (state) => {
        if (state.snackBar == false) {
            state.snackBar = true;
        } else {
            state.snackBar = false;
            state.text = '';
        }
    },
    setSnackBarText : (state, text) => {
        state.text = text;
    },
}

const actions = {
    activeSnack : function({ commit }, data){
        commit('setSnackBar');
    },
    setSnackBarText : function({ commit }, data){
        commit('setSnackBarText', data.text);
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/SnackBarModule.js